import React from 'react';

export const Footer = () => {
    return null
}


// WEBPACK FOOTER //
// ./src/components/modules/FooterContent.js